import { fileDownload } from 'Admin/Component/AdFunc'
import '_Asset/css/User/Page/UiComponent/text.css'

const Text = () => {
  return (
    <div className="componentBox">
      <div className="pageTit">
        <h2>Text <button type="button" className="btn round_10 sm sfrtBlue" onClick={() => fileDownload('ui_component', 'pgui.css')}>UI Component CSS 다운로드</button></h2>
        <p>font: Roboto, "Noto Sans KR", sans-serif</p>
      </div>
      
      <div className="table list_1 text">
        <table>
          <thead>
            <tr>
              <th>Class Name</th>
              <th>Rems</th>
              <th>PX</th>
              <th>Line Height</th>
              <th width="600px">Example</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>h1</td>
              <td>2rem</td>
              <td>28px</td>
              <td>1.4</td>
              <td><h1>Good, cheap flights still exist.<br />Here's how you can find them.</h1></td>
            </tr>
            <tr>
              <td>h2</td>
              <td>1.5rem</td>
              <td>21px</td>
              <td>1.5</td>
              <td><h2>Good, cheap flights still exist.<br /> Here's how you can find them.</h2></td>
            </tr>
            <tr>
              <td>h3</td>
              <td>1.17rem</td>
              <td>16.38px</td>
              <td>1.6</td>
              <td><h3>Good, cheap flights still exist.<br /> Here's how you can find them.</h3></td>
            </tr>
            <tr>
              <td>text_14</td>
              <td>1rem</td>
              <td>14px</td>
              <td>1.7</td>
              <td><h4>Good, cheap flights still exist.<br /> Here's how you can find them.</h4></td>
            </tr>
            <tr>
              <td>text_11.62</td>
              <td>0.83rem</td>
              <td>11.62px</td>
              <td>1.8</td>
              <td><h5>Good, cheap flights still exist.<br /> Here's how you can find them.</h5></td>
            </tr>
            <tr>
              <td>text_9.38</td>
              <td>0.67rem</td>
              <td>9.38px</td>
              <td>1.9</td>
              <td><h6>Good, cheap flights still exist.<br /> Here's how you can find them.</h6></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Text